module.exports = __webpack_public_path__ + "static/partner-d3be634a62ced836a66c398817280399.png";